import Vue from "vue";
import { ActionTree, MutationTree, GetterTree } from "vuex";

const initialState: PortState = {
  all: [],
  lags: [],
  rlinkxPorts: [],
};

const getters: GetterTree<PortState, RootState> = {
  all(state: PortState): Port[] {
    return state.all;
  },
  lags(state: PortState): Lag[] {
    return state.lags;
  },
  dirtyPorts(state: PortState): boolean {
    return !!state.all.find((p: Port) => p.member_of.hasOwnProperty("dirty") && p.member_of.dirty);
  },
  rlinkxPorts(state: PortState): RlinkxPort[] {
    return state.rlinkxPorts;
  },
};

const mutations: MutationTree<PortState> = {
  RESET(state: PortState) {
    state.all = [];
  },

  SET_MODELS(state: PortState, payload: Port[]) {
    payload.forEach((port) => {
      delete port?.vlan;
    });
    state.all = payload.sort((a: Port, b: Port) => a.port_number - b.port_number);
  },

  SET_LAGS(state: PortState, payload: Lag[]) {
    state.lags = payload;
  },

  SET_RLINKX_PORTS_MODELS(state: PortState, payload: RlinkxPort[]) {
    state.rlinkxPorts = payload;
  },

  UPDATE_PORT_GROUP_MEMBER(state: PortState, payload: { port_number: number; member: PortMember }) {
    const index = state.all.findIndex((port: Port) => port.port_number === payload.port_number);

    if (index !== -1) {
      state.all[index].member_of = payload.member;
    }
  },
};

const actions: ActionTree<PortState, RootState> = {
  reset({ commit }) {
    commit("RESET");
  },
  index({ commit, rootState, state }, stash?: boolean) {
    if (state.all.length > 0 && !stash) {
      return new Promise((resolve) => resolve(this.getters["port/all"]));
    }

    return rootState.api
      .get(`ports/port`)
      .then((response: { data: Port[] }) => {
        commit("SET_MODELS", response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },

  indexRlinkxPorts({ commit, rootState, state }) {
    return rootState.api
      .get(`rlinkx/ports`)
      .then((response: { data: Port[] }) => {
        commit("SET_RLINKX_PORTS_MODELS", response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },

  read({ commit, rootState, state }, payload: ReadPortPayload) {
    return rootState.api
      .get(`ports/port/${payload.port_number}`)
      .then((response: { data: Port }) => {
        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },

  update({ commit, rootState, state }, payload: Port[]) {
    return rootState.api
      .put(`ports/port`, payload)
      .then((response: { data: Port[] }) => {
        commit("SET_MODELS", payload);

        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },

  changeGroupMembership({ commit, rootState, state }, payload: ChangeGroupMembershipPayload) {
    commit("UPDATE_PORT_GROUP_MEMBER", { port_number: payload.port_number, member: { dirty: true, type: payload.type, id: payload.id } });
  },

  saveGroupMembership({ commit, rootState, state }, payload: ChangeGroupMembershipPayload) {
    commit("UPDATE_PORT_GROUP_MEMBER", { port_number: payload.port_number, member: { type: payload.type, id: payload.id } });
  },

  getLags({ commit, rootState, state }) {
    return rootState.api
      .get(`ports/lags/lag`)
      .then((response: { data: Lag[] }) => {
        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
